import React from 'react';
import Signin from '../Signin/index'
import {Container} from 'semantic-ui-react'


function SignInModel() {
    return ( 
        <div>
            <Container>
                <Signin/>
            </Container>
        </div>
     );
}

export default SignInModel;